import { render, staticRenderFns } from "./VehicleDeviation.vue?vue&type=template&id=2bb1e3ac&scoped=true&"
import script from "./VehicleDeviation.vue?vue&type=script&lang=js&"
export * from "./VehicleDeviation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb1e3ac",
  null
  
)

export default component.exports